import React from 'react';
import PropTypes from 'prop-types';
import './Message.css';

import imgIcon from './exclamation.svg';

export const Message = ({ copy, icons, ...props}) => {
  return (
        <div className='message lucky_message'>
          <div className='message__icon'>
            <img alt='icon' src={icons ? icons : imgIcon} />
          </div>
          {props.head && <p className="lucky_message_head">{props.head}</p>}
          <div className="lucky_message_text">{copy}</div>
        </div>
  );
};

Message.propTypes = {
  copy: PropTypes.string.isRequired,
  icons: PropTypes.string,
}